export const EXTERNAL_LINKS = {
  DEMO_FORM: 'https://cheetah-mobile.feishu.cn/share/base/form/shrcnOVkryLvYDzl5h5sqJznptb',
  PRODUCT_INFO: 'https://bigshowcdn.cmcm.com/01/ed/8b2d173f-9cdd-4a8d-9fb3-2c82de076a19.pdf',
  LOGIN_URL: 'https://agent.decisionai.cmcm.com/login'
};